import { render, staticRenderFns } from "./unlayerDragDropEditor.vue?vue&type=template&id=2594ac32&scoped=true&"
import script from "./unlayerDragDropEditor.vue?vue&type=script&lang=js&"
export * from "./unlayerDragDropEditor.vue?vue&type=script&lang=js&"
import style0 from "./unlayerDragDropEditor.vue?vue&type=style&index=0&id=2594ac32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2594ac32",
  null
  
)

export default component.exports